export const HOBBES_ICON_URL = 'https://storage.googleapis.com/hobbes-assets/Favicon_Dark.svg';
